import { render } from "./MailHome.vue?vue&type=template&id=13ceaa12&scoped=true&ts=true"
import script from "./MailHome.vue?vue&type=script&lang=ts"
export * from "./MailHome.vue?vue&type=script&lang=ts"

import "./MailHome.vue?vue&type=style&index=0&id=13ceaa12&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13ceaa12"]])

export default __exports__